import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';

const MainSlider = ({ publication, globalIndex }) => {
  const [publicationData, setPublicationData] = useState(null);
  const [contentData, setContentData] = useState(null);
  const [path_to_folder, setPath_to_folder] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [buttonHiding, setButtonHiding] = useState(false);

  useEffect(() => {
    if (publication) setPublicationData(publication);
  }, [publication]);

  useEffect(() => {
    if (!publicationData) return;
    if (publicationData.content) {
      try {
        const parsed = JSON.parse(publicationData.content);
        setContentData(Array.isArray(parsed) ? parsed : []);
      } catch {
        setContentData([]);
      }
    } else {
      setContentData([]);
    }
    if (publicationData.path && publicationData.eng_name) {
      setPath_to_folder(`https://${publicationData.path}${publicationData.eng_name}/`);
    }
  }, [publicationData]);

  const slides = React.useMemo(() => {
    if (!contentData || !Array.isArray(contentData) || !path_to_folder) return [];
    for (const block of contentData) {
      if (!block?.block_content || !Array.isArray(block.block_content)) continue;
      const imgsBlock = block.block_content.find(
        (c) => (c.cotent_type === 'imgs_block' || c.content_type === 'imgs_block') && (c.imgs_names || c.imgs_names === '[]'),
      );
      if (!imgsBlock?.imgs_names) continue;
      let namesArr = [];
      try {
        namesArr = typeof imgsBlock.imgs_names === 'string' ? JSON.parse(imgsBlock.imgs_names) : imgsBlock.imgs_names;
      } catch {
        continue;
      }
      if (!Array.isArray(namesArr)) continue;
      const imgNames = namesArr
        .filter((name) => name && name !== 'none')
        .map((name) => (name && name.includes('\\') ? name.substring(name.lastIndexOf('\\') + 1) : name));

      let signaturesArr = [];
      if (imgsBlock.imgs_signatures && imgsBlock.imgs_signatures !== 'none' && imgsBlock.imgs_signatures !== '[]') {
        try {
          const parsed = typeof imgsBlock.imgs_signatures === 'string' ? JSON.parse(imgsBlock.imgs_signatures) : imgsBlock.imgs_signatures;
          signaturesArr = Array.isArray(parsed) ? parsed : [];
        } catch {
          signaturesArr = [];
        }
      }

      return imgNames.map((imgName, index) => {
        const raw = signaturesArr[index];
        const signature =
          raw != null && String(raw).trim() !== '' && String(raw).trim().toLowerCase() !== 'none'
            ? String(raw).trim()
            : null;
        return { imgName, signature };
      });
    }
    return [];
  }, [contentData, path_to_folder]);

  const goToSlide = (index) => {
    setButtonHiding(true);
    setTimeout(() => {
      setCurrentSlide(index);
      setButtonHiding(false);
    }, 200);
  };

  const prevSlide = () => {
    if (slides.length <= 1) return;
    goToSlide((currentSlide - 1 + slides.length) % slides.length);
  };

  const nextSlide = () => {
    if (slides.length <= 1) return;
    goToSlide((currentSlide + 1) % slides.length);
  };

  const handleDetailsClick = (e, href) => {
    e.preventDefault();
    if (href) window.open(href, '_blank', 'noopener,noreferrer');
  };

  if (!path_to_folder || slides.length === 0) return null;

  return (
    <div className={styles.mainSlider}>
      <div className={styles.sliderContainer}>
        <div
          className={styles.slidesWrapper}
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
          {slides.map((slide, index) => (
            <div key={index} className={styles.slide}>
              <div className={styles.slideContent}>
                <img
                  src={path_to_folder + slide.imgName}
                  alt={`Слайд ${index + 1}`}
                  className={styles.slideImage}
                />
                {slide.signature && (
                  <a
                    href={slide.signature.startsWith('http') ? slide.signature : `https://${slide.signature}`}
                    onClick={(e) => handleDetailsClick(e, slide.signature.startsWith('http') ? slide.signature : `https://${slide.signature}`)}
                    className={`${styles.detailsButton} ${buttonHiding ? styles.hiding : ''}`}
                    style={{ pointerEvents: buttonHiding ? 'none' : 'auto' }}>
                    Подробнее
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>

        {slides.length > 1 && (
          <>
            <button type='button' className={styles.prevButton} onClick={prevSlide} aria-label='Предыдущий слайд'>
              ‹
            </button>
            <button type='button' className={styles.nextButton} onClick={nextSlide} aria-label='Следующий слайд'>
              ›
            </button>
          </>
        )}

        {slides.length > 1 && (
          <div className={styles.dotsContainer}>
            {slides.map((_, index) => (
              <button
                key={index}
                type='button'
                className={`${styles.dot} ${index === currentSlide ? styles.activeDot : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Перейти к слайду ${index + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MainSlider;
